/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/github" */ '@atlassian/logo-third-party/github'
		).then((m) => m.GitHubIcon),
	{ moduleId: '@atlassian/logo-third-party/github' },
);

const LazyForgePioGithubIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-github-prod" */ './utils').then(
			(m) => m.ForgePioGithubIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon' },
);

const LazyForgePioGithubSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-github-prod-search-result" */ './utils').then(
			(m) => m.ForgePioGithubSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioGithubIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioGithubIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgePioGithubSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioGithubSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
